import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface Step9CompletionProps {
    vendor?: string;
    onGoToProducts: () => void;
    status?: string;
}


const PublishToAssistant: React.FC<Step9CompletionProps> = ({
    vendor,
    onGoToProducts,
    status
}) => {

    return (
        <div className="flex flex-col justify-between items-end">

            {/* Status Section */}
            <Card className="bg-white border border-gray-200 shadow-sm">
                <CardHeader>
                    <CardTitle className="text-lg font-semibold">Status</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    {/* Publish to Production */}
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <h3 className="text-sm font-medium">Publish to Assistant</h3>
                        </div>

                        {/* Completion Message */}
                        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                            <div className="flex items-center space-x-3">
                                <CheckCircle className="h-6 w-6 text-green-600" />
                                <div>
                                    <h4 className="text-sm font-medium text-green-800">Assistant Deployment Complete</h4>
                                    <p className="text-sm text-green-700 mt-1">Your product catalog is now live on Assistant.</p>
                                </div>
                            </div>
                        </div>

                        {/* Back to Home Button */}
                        <Button
                            onClick={onGoToProducts}
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center gap-2"
                        >
                            Go to Products
                        </Button>
                        <div className="space-y-3">
                            <div className="flex justify-between">
                                <span className="text-sm text-gray-600">Status:</span>
                                <Badge className="bg-blue-100 text-blue-700">{status || 'Pending'}</Badge>
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default PublishToAssistant; 